import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'separateFilesTab',
    'documentTypeSelect',
    'singleFileTab',
    'rectoInput',
    'versoInput'
  ]

  static values = {
    allowedTypes: Array
  }

  checkDocumentType() {
    if (!this.hasDocumentTypeSelectTarget) return

    const selectedType = this.documentTypeSelectTarget.value
    const shouldShowSeparateTab = this.allowedTypesValue.includes(selectedType)

    if (shouldShowSeparateTab) {
      this.separateFilesTabTarget.classList.remove('d-none')
    } else {
      this.separateFilesTabTarget.classList.add('d-none')
      this.clearRectoVersoInputs()

      const separateTabButton = this.separateFilesTabTarget.querySelector('button')

      if (separateTabButton?.classList.contains('active') && this.hasSingleFileTabTarget) {
        this.singleFileTabTarget.click()
      }
    }
  }

  clearRectoVersoInputs() {
    if (this.hasRectoInputTarget) {
      this.rectoInputTarget.dispatchEvent(new CustomEvent('document-input:clear', { bubbles: true }))
    }

    if (this.hasVersoInputTarget) {
      this.versoInputTarget.dispatchEvent(new CustomEvent('document-input:clear', { bubbles: true }))
    }
  }
}
